import { Link } from "react-router-dom";

// Plain description of what the site's forms store. Keep it in step with the code: api/waitlist.py,
// api/public_reports.py, api/public.py (appeals), api/developer.py, services/ip_privacy.py.
export default function Privacy() {
  return (
    <section data-testid="privacy-page" className="space-y-6 hs-prose">
      <h1 className="hs-display text-3xl md:text-4xl">Privacy</h1>
      <p className="text-muted">What HerdSafe keeps when you use the forms on this site, and why. Last updated 11 October 2026.</p>

      <h2 className="hs-display text-xl">What we collect</h2>
      <ul className="list-disc space-y-2 pl-6">
        <li><Link className="hs-link" to="/early-access">Early access</Link>: your email, and the company, role and MCP servers
          you choose to tell us.</li>
        <li><Link className="hs-link" to="/report">Report a server</Link>: the server name or URL, what you wrote about what
          happened, and your email if you give one.</li>
        <li><Link className="hs-link" to="/appeal">Appeal</Link>: your email, the item you are appealing and your message.</li>
        <li><Link className="hs-link" to="/get-key">Developer keys and the watchlist</Link>: your email, the servers you
          add to your watchlist, when you signed in, and which emails we sent you (address, subject and time, never the
          content). Sign-in links, sessions and API keys are stored only as one-way hashes.</li>
        <li>The <code>herdsafe</code> command-line tool sends us only the names of the packages and remote servers in your
          MCP configs (never your environment variables, headers or tokens).</li>
        <li>For these forms, and for anonymous lookups on the Check page and the API, we keep a <strong>one-way, keyed hash
          of your IP address</strong>, never the address itself. We use it to limit how often one address can submit and to
          spot abuse.</li>
      </ul>

      <h2 className="hs-display text-xl">Why</h2>
      <p>To review reports and appeals, to reply to you if you gave us an email, to contact you about early access, and to
        keep the forms from being abused. We do not use it for advertising.</p>

      <h2 className="hs-display text-xl">Where it is kept and who handles it</h2>
      <p>It is stored in our database, which is hosted on Railway. The site is delivered through Cloudflare, and when the
        human-verification check is switched on it is Cloudflare Turnstile, which runs in your browser. If you give an email
        on the report form, we may send you a confirmation through our email provider, Resend, which also delivers sign-in
        links and watchlist emails. These providers may keep
        their own standard request logs.</p>
      <p><strong>We never sell your data, and we do not share it with anyone for their own use.</strong> The only other
        companies that handle it are the ones above, which run the service for us.</p>

      <h2 className="hs-display text-xl">How long</h2>
      <p>We keep it until you ask us to delete it. We do not delete it automatically yet. If we block a submitter for abuse,
        we keep a keyed hash of their IP address and email (not the address itself) for as long as the block lasts.</p>

      <h2 className="hs-display text-xl">Seeing or deleting your data</h2>
      <p>Email <a className="hs-link" href="mailto:support@herdsafe.ai">support@herdsafe.ai</a> from the address you used,
        and tell us whether you want a copy of what we hold or want it deleted. We will reply by email.</p>
      <p className="text-muted">Please never put passwords, API keys or other secrets in any form.</p>
    </section>
  );
}
